import { Paragraph as ParagraphToExtend } from '@tiptap/extension-paragraph';
import { NodeType } from '../constants';

export const Paragraph = ParagraphToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: 'p'
            },
            style: {
                default: null
            }
        };
    },
    addCommands() {
        return {
            ...this.parent?.(),
            setParagraphClass: (className) => ({ commands }) =>
                commands.updateAttributes(NodeType.PARAGRAPH, { class: className })
        };
    }
});
